import { memo } from "react";
import Main from "./Main";
export default memo(Main);
